// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iIbmw","tabsBox":"styles_tabsBox__vHyp4","createButton":"styles_createButton__2V98F"};